import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Modal } from "react-bootstrap";
import DuplicateConfigForm from '../comptabilite/CodeConfiguration/Comp/DuplicateConfigForm'

const BtnDuplicateComptaConfig = (props) => {
    const t = useTranslate();
    const [showDuplicateForm,setShowDuplicateForm] = useState(false)

    return(<>
        <Modal size="md" show={showDuplicateForm} onHide={() => setShowDuplicateForm(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{t('duplicateComptaConfigFrom')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DuplicateConfigForm 
                    idCompany={props.idCompany}
                    config={props.config}
                    setReload={props.setReload}
                    selectType={props.selectType}
                    setShowDuplicateForm={setShowDuplicateForm}
                    company={props.company}
                />
            </Modal.Body>
        </Modal>
        <button 
            className="btn btn-info"
            onClick={()=>setShowDuplicateForm(true)}
        >
            {t('duplicateExistingComptaConfig')}
        </button>
    </>
    )
}

export default BtnDuplicateComptaConfig;